import SinglePage from '@dex/bubl-dash/src/lib/pages/SinglePage';
import FormEntrySingleView from './Components/FormEntrySingleView';
// import FormEntrySingleEdit from './Components/FormEntrySingleEdit';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "View",
        zone: settings.zone,
        path: settings.key + "/:id/view",
        caps: settings.viewCaps,
        component: SinglePage,
        componentProps: {
            getFetch: settings.singleFetch,
            getFetchParams: settings.singleFetchParams,
            header: {
                getTitle: settings.singleTitle,
                getTabs: settings.singleTabs
            },
            page: FormEntrySingleView,
        },
    });

    // app.addRoute({
    //     name: settings.key + "Edit",
    //     zone: settings.zone,
    //     path: settings.key + "/:id/edit",
    //     caps: settings.viewCaps,
    //     component: SinglePage,
    //     componentProps: {
    //         getFetch: settings.singleFetch,
    //         getFetchParams: settings.singleFetchParams,
    //         header: {
    //             getTitle: settings.singleTitle,
    //             getTabs: settings.singleTabs
    //         },
    //         page: FormEntrySingleEdit,
    //     },
    // });

}